/* Only pack pages: preserve the existing native form and its current variant/quantity. */
(() => {
  function mount(root) {
    const form = root.querySelector('form[action*="/cart/add"]');
    if (!root.querySelector('[data-bqc-pack-add]') || !form || form.dataset.bqcPackLock) return;
    form.dataset.bqcPackLock = 'true';
    let busy = false;
    let restore = [];
    function reset() {
      busy = false;
      restore.forEach(({ button, disabled, label, text }) => {
        button.disabled = disabled;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = text;
      });
      restore = [];
    }
    form.addEventListener('submit', event => {
      if (!event.submitter?.matches('[data-bqc-submit]')) return;
      if (busy) { event.preventDefault(); return; }
      if (event.defaultPrevented) return;
      busy = true;
      restore = Array.from(root.querySelectorAll('[data-bqc-submit]')).map(button => {
        const label = button.querySelector('[data-bqc-submit-label]');
        const previous = { button, disabled: button.disabled, label, text: label?.textContent };
        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Añadiendo…';
        return previous;
      });
      /* Let native form serialization finish before disabling the submit controls. */
      setTimeout(() => { if (busy) restore.forEach(({ button }) => { button.disabled = true; }); }, 0);
    });
    window.addEventListener('pageshow', reset);
  }
  function init(scope = document) { scope.querySelectorAll('[data-bqc-product-ui]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
